<template>
    <div class="visualization progress-visualization" v-loading="loading" element-loading-spinner="presupuesto-loader">
        <h3>Estado de Avance</h3>
        <div class="row">
            <div class="col-sm-10">
                <el-radio-group v-model="periodo">
                    <el-radio-button v-for="p in periodos" :key="p" :label="p"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="col-sm-2 text-right">
                <div class="mode-selector">
                    <span class="title">Ver como</span>
                    <div class="view-buttons">
                        <el-tooltip content="Gráfico">
                            <a href="#" @click.prevent="mode = 'chart'" :class="{active: mode === 'chart'}">
                                <i class="material-icons">dashboard</i>
                            </a>
                        </el-tooltip>
                        <el-tooltip content="Tabla">
                            <a href="#" @click.prevent="mode = 'table'" :class="{active: mode === 'table'}">
                                <i class="material-icons">view_list</i>
                            </a>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>


        <line-chart :width="1110" :height="510" v-show="mode === 'chart'" :data="filteredData" :labels="filteredLabels" :dimensions="dimensions"></line-chart>
        <table-chart :height="510" :data="filteredData" :labels="filteredLabels" v-show="mode === 'table'"></table-chart>


        <visualization-footer :url="this.url"></visualization-footer>



    </div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';
    import moment from 'moment';
    import LineChart from '../Charts/MultiLine';
    import TableChart from '../Charts/MultiTable';
    import VisualizationFooter from './Common/Footer';

    export default{
        data: function(){


            return {
                periodo: this.$store.state.defaultYear,
                periodos: [],
                loading: false,
                data: [],
                dimensions: {time: ['mes']},
                mode: 'chart',
                labels: ['Devengado','Pagado'/*,'Ley vigente mensualizada'*/],
            }
        },
        props: ['institution', 'showPayments'],
        computed:{
            where: function(){
                let where = {
                    periodo: this.periodo,
                    partida: this.institution.partida
                };
                if(this.institution.capitulo)
                    where.capitulo = this.institution.capitulo;
                if(this.institution.area)
                    where.area = this.institution.area;

                return where;
            },
            url: function(){
                return [
                    '/api/v1/data/pagos?metric=devengo&group-by='+JSON.stringify(['mes'])+'&where='+JSON.stringify(this.where),
                    '/api/v1/data/pagos?metric=monto&group-by='+JSON.stringify(['mes'])+'&where='+JSON.stringify(this.where),
                    //'/api/v1/data/aprobados?metric=monto&group-by='+JSON.stringify(['mes'])+'&where='+JSON.stringify(this.where),
                ];
            },
            filteredData: function(){
                return this.showPayments ? this.data : this.data.filter((d,i) => {return i === 0});
            },
            filteredLabels: function(){
                return this.showPayments ? this.labels : this.labels.filter((d,i) => {return i === 0});
            }
        },
        methods:{
            refreshData: function(){
                this.loading = true;
                Promise.all([
                    axios.get(this.url[0]),
                    axios.get(this.url[1]),
                    //axios.get(this.url[2]),
                ]).then((response) => {
                    this.loading = false;
                    this.data = response.map((d)=>{
                        return d.data.map(function(d){
                            return _.assign(d, {nombre_mes: moment(d.mes, 'M').format('MMMM')});
                        })
                    });

                })
            }
        },
        watch:{
            periodo: function(value){
                this.$store.commit("setDefaultYear", value)
                this.refreshData();
            }
        },
        components:{
            LineChart,
            TableChart,
            VisualizationFooter
        },
        mounted: function(){
            this.refreshData();

            axios.get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
                .then(response => {
                    this.periodos = response.data.map(d => {return d.periodo});
                })
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/Progress.vue